var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterStageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    fill: "#fff",
    stroke: "#435660",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.54 40.656c-1.692 1.035-3.648 1.846-5.52 2.345l.64 2.388a24.01 24.01 0 006.05-2.57l-1.17-2.163z",
    fill: "#B74291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 23.98l-2.388-.64a18.074 18.074 0 000 9.32l2.388-.64a15.595 15.595 0 010-8.037",
    fill: "#182642"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.491 15.743c-.99-.755-2.977-2.08-5.47-2.743l.639-2.388c2.907.777 4.505 1.893 6.025 2.95l-1.197 2.18h.003z",
    fill: "#B74291"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.02 12.999l.64-2.388a18.074 18.074 0 00-9.32 0l.64 2.388a15.595 15.595 0 018.037 0M17.023 38.977l-1.745 1.748a17.893 17.893 0 008.07 4.66l.638-2.388a15.437 15.437 0 01-6.96-4.02",
    fill: "#182642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.983 43.001l-.64 2.388c3.049.814 6.268.814 9.32 0L32.023 43c-2.63.702-5.407.702-8.037 0",
    fill: "#22A6DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.023 17.02l-1.745-1.746a17.893 17.893 0 00-4.66 8.07l2.388.638a15.436 15.436 0 014.02-6.96M17.606 25.283l-2.392-.625a13.13 13.13 0 00.046 6.76l2.38-.657a10.628 10.628 0 01-.034-5.482M25.26 17.77l-.638-2.388a12.993 12.993 0 00-5.854 3.381l1.745 1.749a10.537 10.537 0 014.744-2.742",
    fill: "#B74291"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.644 30.762l-2.38.657a12.972 12.972 0 003.42 5.829l1.734-1.76a10.56 10.56 0 01-2.774-4.726z",
    fill: "#182642"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.18 38.202l-.625 2.39a13.13 13.13 0 006.76-.045l-.657-2.38c-1.791.491-3.684.502-5.482.038",
    fill: "#B74291"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.418 35.494l-1.734 1.76a13 13 0 005.874 3.342l.625-2.39a10.542 10.542 0 01-4.765-2.712z",
    fill: "#22A6DA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.379 19.832c2.472 0 4.084.794 5.695 1.998l-1.453 2.68c-1.159-.885-2.427-1.545-4.221-1.545-3.223 0-5.176 2.222-5.176 5.06 0 2.837 1.953 5.06 5.176 5.06 1.794 0 3.066-.657 4.22-1.542l1.455 2.68c-1.612 1.204-3.224 1.997-5.696 1.997-5.38 0-8.716-3.767-8.716-8.192 0-4.424 3.336-8.192 8.716-8.192",
    fill: "#3D3945"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.343 17.739a13.28 13.28 0 00-5.014-2.543l-.618 2.392a10.698 10.698 0 014.428 2.377l1.207-2.23-.003.004z",
    fill: "#22A6DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterStageIcon);
export default __webpack_public_path__ + "static/media/center-stage-icon.33e5b0fa8019a2675c73511c1c2a3fc9.svg";
export { ForwardRef as ReactComponent };